/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 9 hook(s) need dependency review; fix each and remove this directive */
import { getBackendUrl } from "@Utils";
import type React from "react";
import { useTranslation, untranslated } from "@i18n";
import { fetchRevisionSeries } from "../../features/files/components/FileVersion/revisionSeriesShared";
import {
  getEffectiveSequenceRules,
  type RevisionSequenceRules,
  type RevisionSequenceType,
} from "../../../../helpers/revisionPattern";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import * as XLSX from "xlsx";
import { BUTTON_TYPES } from "../../cubeComponent/constants/globalVariable";
import ButtonComponent from "../../cubeComponent/form/ButtonComponent";
import ModalStateDialogComponent from "../../cubeComponent/html/modal/ModalWithState";
import { importScheduleTasks } from "../../actions/task";
import { useParams } from "react-router-dom";
import { showToastNotification } from "../../reducers/toastSlice";
import {
  SOMETHING_WENT_WRONG,
  TOAST_TYPE_ERROR,
  TOAST_TYPE_SUCCESS,
  TOAST_TYPE_WARNING,
} from "../../services/constants";
import { useDispatch, useSelector } from "react-redux";
import AutoComplete from "../../cubeComponent/Mui_Form/AutoComplete";
import TextFieldComponent from "../../cubeComponent/Mui_Form/TextFieldComponent";
import axiosWrapper from "../../services/axiosWrapper";
import type { GetFormTemplateResponse } from "@ServerTypes/projects/project.schema";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";

import SlickGrid1 from "../../cubeComponent/html/SlickGrid1";
import {
  getPurchaseUnits,
  importCostDatabaseItemsFromExcelSheet,
  saveEstimateItemsFromExcelSheet,
} from "../../actions/estimation";
import ToggleSwitchComponent from "../../cubeComponent/form/ToggleSwitchComponent";
import ToolTipComponent from "../../cubeComponent/html/tooltip";
import SelectDropDown from "@CubeComponents/Mui_Form/SelectDropDown";
import {
  dateTypeDatasource,
  excelImportSources,
  excludeAutoMatchingColumns,
  formatDateFieldValue,
  getExampleFields,
  getGridColumns,
  getMatchDropdownDataSource,
  getRequiredFields,
  getSampleFile,
  parseCsvText,
  saveContainers,
  scheduleDropDownDataSource,
  validateAssetData,
  validateEstimateData,
  validateScheduleData,
  wbsPathTypeDatasource,
  xmlDropdownDatasource,
} from "./ExcelHelper";
import { formCategories, MAX_EXCEL_IMPORT_CONTAINERS } from "@Helpers";
import {
  importExcelContainers,
  maximiseFileUpload,
  setFileUploadProperties,
  setCurrentFileUploadProperties,
  fetchFilesFromFolder,
  ensureFolderPathExists,
} from "../../actions/fileUpload";

import IconComponent from "@CubeComponents/icons";
import { portalCreateRoot as createRoot } from "@CubeComponents/html/cellPortals";
import type { ImportAssetsFromExcelResponse } from "@ServerTypes/assets/assets.schema";
import { formController } from "@Actions/Forms";
import { RootState } from "@Reducers/index";

function ExcelImport({
  source,
  sourceId,
  showImportModal,
  setShowImportModal,
  refreshDataGrid,
  currentData,
  importMode,
}: any) {
  const { t } = useTranslation();
  const [file, setFile] = useState<any>(null);
  const [allJsonData, setAllJsonData] = useState<any>(null);
  const [filteredJsonData, setFilteredJsonData] = useState(null);
  const [enableNextButton, setEnableNextButton] = useState(false);
  const estimateData = useSelector((state: RootState) => state.estimateData);
  const [purchaseUnitsList, setPurchaseUnitsList] = useState<any[]>([]);
  const [customFields, setCustomFields] = useState<any>([]);
  const [projectLevelFields, setProjectLevelFields] = useState<any[]>([]);
  const [allColumnNames, setAllColumnNames] = useState([]);
  const [wbsPathTypeIndex, setWbsPathTypeIndex] = useState<number | null>(null);
  const [startDateTypeFormat, setStartDateTypeFormat] = useState<string | null>(null);
  const [finishDateTypeFormat, setFinishDateTypeFormat] = useState<string | null>(null);
  const [headerIndex, setHeaderIndex] = useState<number | null>(null);
  const [finalData, setFinalData] = useState([]);
  const [showOnlyErrors, setShowOnlyErrors] = useState(true);
  const [currentTab, setCurrentTab] = useState("Upload File");
  const [columnMapper, setColumnMapper] = useState<any>({});
  const [notValidPredecessors] = useState([]);
  const [estimateIcorrectData, setEstimateIcorrectData] = useState([]);
  const [scheduleIcorrectData, setScheduleIcorrectData] = useState([]);
  const [isEstimateDataValid, setIsEstimateDataValid] = useState(true);
  const [isScheduleDataValid, setIsScheduleDataValid] = useState(true);
  const [isXml, setIsXml] = useState(false);
  const [xmlSoftware, setXmlSoftware] = useState("P6");
  const [holidays, setHolidays] = useState(null);
  const [workWeek, setWorkWeek] = useState(["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"]);
  const [workTimings, setWorkTimings] = useState([{ from: 0, to: 24 }]);
  const [calendarArray, setCalendarArray] = useState<any>(null);
  const [calendarDropdownDatasource, setCalendarDropdownDatasource] = useState([]);
  const [selectedCalendar, setSelectedCalendar] = useState("");
  const [timingsDropdownDatasource, setTimingsDropdownDatasource] = useState<any>([]);
  const [workTimingsArray, setWorkTimingsArray] = useState<any[]>([]);
  const [workTimingsForDropDown, setWorkTimingsForDropdown] = useState("");
  const getInitialUploadOption = () => {
    if (importMode === "container") return "complete";
    if (importMode === "file") return "importDirectly";
    return "complete";
  };
  const [uploadOption, setUploadOption] = useState(getInitialUploadOption());
  const [buttonLoading, setButtonLoading] = useState(false);
  const [showErrorReview, setShowErrorReview] = useState(false);
  const [validContainers, setValidContainers] = useState<any>([]);

  const params = useParams<{ scheduleId: string }>();
  const dispatch = useDispatch();
  const dropDownRef = useRef<any>([]);
  const gridRef = useRef<any>(null);
  const estimateValidateRef = useRef<any>(null);
  const validateGridRef = useRef<any>(null);
  const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  const requiredFields: any = getRequiredFields({
    source,
    extraFields: customFields,
    projectLevelFields,
  });
  const exampleFields = getExampleFields({ source, projectLevelFields });

  async function fetchPortalPurchaseUnits() {
    const response = await getPurchaseUnits(null);
    setPurchaseUnitsList(response.data.result ?? []);
  }

  async function fetchCurrentFormTemplate() {
    if (currentData) {
      const response = await axiosWrapper.post<GetFormTemplateResponse>(`${getBackendUrl()}/projects/getFormTemplate`, {
        projectId: currentData.projectId,
        hierarchyId: currentData.hierarchyId,
        resourceType: formCategories.files,
      });
      if (response.data.status && response.data?.data) {
        setCustomFields([response.data.data]);
      }
    }
  }

  async function fetchProjectLevelFields() {
    if (source === excelImportSources.ASSETS && sourceId) {
      const response = await axiosWrapper.post<{
        status: boolean;
        data?: {
          formTemplate: { _id: string | null; template: any[] | null };
          customFields: Record<string, unknown>;
        };
      }>(`${getBackendUrl()}/assets/getProjectLevelAssetFields`, { projectId: sourceId });
      if (response.data.status && response.data.data?.formTemplate?.template) {
        setProjectLevelFields(response.data.data.formTemplate.template);
      }
    }
  }

  const iconFormatter = (row: number, cell: number, value: any, columnDef: any, dataContext: any) => {
    if (!dataContext.type) return "";
    const container = document.createElement("div");
    createRoot(container).render(
      <IconComponent
        name="details"
        width="1.5rem"
        height="1.5rem"
        position="right"
        className="cursor-pointer"
        toolTipContent={dataContext.type}
      />,
    );
    return container;
  };

  const idFormatter = (row: number, cell: number, value: any, columnDef: any, dataContext: any) => {
    if (dataContext.WBSCode) {
      return dataContext.WBSCode;
    }
    return dataContext.customTaskId || "";
  };

  const createFormatterContainer = (styles: Partial<CSSStyleDeclaration> = {}): HTMLDivElement => {
    const container = document.createElement("div");
    container.style.overflow = "hidden";
    Object.assign(container.style, styles);
    return container;
  };

  const errorFormatter = (_row: number, _cell: number, _value: any, _columnDef: any, dataContext: any) => {
    if (!Array.isArray(dataContext.errors) || dataContext.errors.length === 0) return "";
    const errorText = dataContext.errors.join(", ");
    const container = createFormatterContainer({ height: "100%", display: "flex", alignItems: "center" });
    createRoot(container).render(
      <ToolTipComponent position="bottom" content={errorText}>
        <div className="flex items-center gap-2 min-w-0 overflow-hidden w-full">
          <div className="shrink-0 flex items-center">
            <IconComponent name="DetailsRed" width="1rem" height="1rem" />
          </div>
          <span className="text-[#E05650] truncate">{errorText}</span>
        </div>
      </ToolTipComponent>,
    );
    return container;
  };

  const textWithTooltipFormatter = (_row: number, _cell: number, value: any, _columnDef: any, dataContext: any) => {
    const displayText = String(value ?? dataContext?.[_columnDef?.field] ?? "");
    if (!displayText) return "-";
    const container = createFormatterContainer();
    createRoot(container).render(
      <ToolTipComponent position="bottom" content={displayText as any}>
        <span className="truncate block">{displayText}</span>
      </ToolTipComponent>,
    );
    return container;
  };

  const headerFormatter =
    (column: any) => (_row: number, _cell: number, _value: any, _columnDef: any, _dataContext: any) => {
      if (column.isMandatory) {
        const container = document.createElement("div");
        createRoot(container).render(
          <div className="flex">
            <span className="text-2xl leading-4 font-light text-red-500">*</span>
            <p>{column.headerText || column.name}</p>
          </div>,
        );
        return container;
      }
      return column.headerText || column.name || "";
    };

  const getColumnDefinitions = ({
    columnNames,
    allowCheckboxSelection,
    isValidateState,
    source: colSource,
    dateTimeFields,
    dateTimeFieldsMap,
  }: any) => {
    const syncfusionColumns = getGridColumns({
      columnNames,
      allowCheckboxSelection,
      isValidateState,
      source: colSource,
      iconTemplate: iconFormatter,
      errorTemplate: null,
      idTemplate: null,
    });

    return syncfusionColumns
      .filter((col: any) => col.type !== "checkbox")
      .map((col: any, index: number) => {
        const slickColumn: any = {
          id: col.field || `col_${index}`,
          field: col.field || "",
          name: col.headerText || col.field || "",
          minWidth: parseInt(col.width) || 120,
        };

        if (col.template) {
          if (col.width === "40") {
            slickColumn.formatter = iconFormatter;
          }
        }

        if (col.field === "errors") {
          slickColumn.formatter = errorFormatter;
          slickColumn._valueGetter = (row: any) => (Array.isArray(row.errors) ? row.errors.join(", ") : "");
          slickColumn.exportCustomFormatter = (
            _row: any,
            _cell: any,
            _value: any,
            _columnDef: any,
            dataContext: any,
          ) => (Array.isArray(dataContext.errors) ? dataContext.errors.join(", ") : "");
        }

        if (col.isPrimaryKey && colSource === excelImportSources.SCHEDULE) {
          slickColumn.formatter = idFormatter;
        }

        if (col.isMandatory) {
          slickColumn.headerFormatter = headerFormatter(col);
        }

        const isDateTimeField = col.type === "date" || dateTimeFields?.includes(col.field);
        if (isDateTimeField) {
          const displayAs = col.displayAs ?? dateTimeFieldsMap?.[col.field];
          const dateExportGetter = (row: any) => formatDateFieldValue(row[col.field], displayAs);
          slickColumn._valueGetter = dateExportGetter;
          slickColumn.exportCustomFormatter = (_row: any, _cell: any, _value: any, _columnDef: any, dataContext: any) =>
            dateExportGetter(dataContext);
          slickColumn.formatter = (_row: number, _cell: number, value: any, columnDef: any, dataContext: any) => {
            const rawVal = value ?? dataContext?.[columnDef?.field];
            const displayText = formatDateFieldValue(rawVal, displayAs);
            if (!displayText) return "-";
            const container = createFormatterContainer();
            createRoot(container).render(
              <ToolTipComponent position="bottom" content={displayText as any}>
                <span>{displayText}</span>
              </ToolTipComponent>,
            );
            return container;
          };
        }

        if (!slickColumn.formatter) {
          slickColumn.formatter = textWithTooltipFormatter;
        }

        if (!slickColumn._valueGetter) {
          slickColumn._valueGetter = (row: any) => {
            const val = row[col.field];
            if (Array.isArray(val)) return val.join(", ");
            return val ?? "";
          };
        }

        return slickColumn;
      });
  };

  const handleRowSelectionChanged = useCallback(
    async (selectedRowIds: any[], dataView: any) => {
      if (selectedRowIds.length === 1) {
        const selectedRecord = dataView.getItemById(selectedRowIds[0]);
        if (selectedRecord) {
          const selectedRow = Object.entries(selectedRecord)
            .filter(([key]: any) => key !== "id")
            .map(([, val]: any) => (typeof val === "string" ? val.trim() : String(val ?? "").trim()))
            .filter((val: any) => val !== "");
          setAllColumnNames(selectedRow as any);
          const selectedIndex = dataView.getIdxById(selectedRowIds[0]);
          setHeaderIndex(selectedIndex);
          const temp = allJsonData.filter((data: any, index: number) => index > selectedIndex);
          const convertArrayDataToObject = (data: any, colName: any) => {
            const resultObject: any = {};
            colName.forEach((value: any, index: number) => {
              resultObject[value] = data[index];
            });
            return resultObject;
          };
          const mappedData = temp.map((data: any) => convertArrayDataToObject(data, selectedRow));
          if (source == "assets") {
            const templateNames = new Set();
            if (Array.isArray(mappedData) && mappedData.length) {
              mappedData.forEach(
                (item: any) => item.Template?.length && templateNames.add(item.Template.trim().toLowerCase()),
              );
            }
            const formsList = await formController({ value: { resourceType: formCategories.assets } });
            if ((formsList.data?.result as any)?.length) {
              const templates = (formsList.data.result as any[])
                .filter((form: any) => templateNames.has(form.name.toLowerCase()))
                .map((form: any) => ({
                  template: form.template,
                  _id: form._id,
                  name: form.name.toLowerCase(),
                }));
              setCustomFields(templates);
            }
          }

          setFilteredJsonData(mappedData);
          setEnableNextButton(true);
        }
      } else {
        setEnableNextButton(false);
        setFilteredJsonData(null);
        setAllColumnNames([]);
        setHeaderIndex(null);
      }
    },
    [allJsonData, source],
  );

  const gridColumnDefinitions = useMemo(
    () => (props: any) =>
      getColumnDefinitions({
        columnNames: props.columnNames,
        allowCheckboxSelection: true,
        isValidateState: props.isValidateState,
        source: props.source,
        dateTimeFields: props.dateTimeFields,
        dateTimeFieldsMap: props.dateTimeFieldsMap,
      }),
    // getColumnDefinitions is a new ref each render but state-independent — adding it would rebuild the grid; safe to omit.

    [],
  );

  const scheduleTreeColumnDefinitions = useMemo(
    () =>
      getColumnDefinitions({
        columnNames: null,
        allowCheckboxSelection: false,
        isValidateState: false,
        source,
      }),
    // getColumnDefinitions is a new ref each render but state-independent — adding it would rebuild the grid; safe to omit.

    [source],
  );

  const scheduleValidateColumnDefinitions = useMemo(
    () =>
      getColumnDefinitions({
        columnNames: null,
        allowCheckboxSelection: false,
        isValidateState: true,
        source,
      }),
    // getColumnDefinitions is a new ref each render but state-independent — adding it would rebuild the grid; safe to omit.

    [source],
  );

  const estimateTreeColumnDefinitions = useMemo(
    () =>
      getColumnDefinitions({
        columnNames: null,
        allowCheckboxSelection: false,
        isValidateState: false,
        source,
      }),
    // getColumnDefinitions is a new ref each render but state-independent — adding it would rebuild the grid; safe to omit.

    [source],
  );

  const estimateValidateColumnDefinitions = useMemo(
    () =>
      getColumnDefinitions({
        columnNames: null,
        allowCheckboxSelection: false,
        isValidateState: true,
        source,
      }),
    // getColumnDefinitions is a new ref each render but state-independent — adding it would rebuild the grid; safe to omit.

    [source],
  );

  const assetsColumnDefinitions = useMemo(
    () =>
      getColumnDefinitions({
        columnNames: requiredFields,
        allowCheckboxSelection: false,
        isValidateState: true,
        source,
      }),

    [customFields, projectLevelFields],
  );

  const getGridComponent = useCallback(
    (props: any) => (
      <SlickGrid1
        key={props.rowSelected ? "row-select" : "no-select"}
        ref={gridRef}
        dataset={props.dataSource}
        columnDefinitions={gridColumnDefinitions(props)}
        gridOptions={{ rowHeight: 34, ...(props.height !== undefined && { gridHeight: props.height }) }}
        disableCheckBoxSelection={!props.rowSelected}
        excelExport={props.allowExport}
        onSelectedRowIdsChanged={
          props.rowSelected
            ? (args: any) => {
                const selectedRowIds = args?.detail?.args?.selectedRowIds ?? [];
                const dataView = gridRef.current?.dataView;
                if (dataView) {
                  handleRowSelectionChanged(selectedRowIds, dataView);
                }
              }
            : undefined
        }
      />
    ),
    [gridColumnDefinitions, handleRowSelectionChanged],
  );

  const scheduleFinalTreeGrid = useCallback(
    (props: any) => (
      <SlickGrid1
        dataset={props.dataSource}
        columnDefinitions={scheduleTreeColumnDefinitions}
        idMapping="mysqlId"
        parentIdMapping="parentId"
        gridOptions={{ rowHeight: 34 }}
      />
    ),
    [scheduleTreeColumnDefinitions],
  );

  const scheduleValidateGrid = useCallback(
    (props: any) => (
      <SlickGrid1
        ref={validateGridRef}
        dataset={props.dataSource}
        columnDefinitions={scheduleValidateColumnDefinitions}
        gridOptions={{ rowHeight: 34 }}
      />
    ),
    [scheduleValidateColumnDefinitions],
  );

  const estimateFinalTreeGrid = useCallback(
    (props: any) => (
      <SlickGrid1
        dataset={props.dataSource}
        columnDefinitions={estimateTreeColumnDefinitions}
        idMapping="rowNo"
        parentIdMapping="parent"
        gridOptions={{ rowHeight: 34 }}
      />
    ),
    [estimateTreeColumnDefinitions],
  );

  const estimateValidateGrid = useCallback(
    (props: any) => (
      <SlickGrid1
        ref={estimateValidateRef}
        dataset={props.dataSource}
        columnDefinitions={estimateValidateColumnDefinitions}
        gridOptions={{ rowHeight: 34 }}
      />
    ),
    [estimateValidateColumnDefinitions],
  );

  const handleDropdownChange = (newValue: any, columnName: string) => {
    const selectedValue = newValue?.value?.trim() || "";
    let tempObj: any = {};
    let columnNameNotFound = true;
    Object.keys(columnMapper).forEach((key) => {
      if (selectedValue === columnMapper[key]) {
        tempObj = {
          ...columnMapper,
          [columnName]: selectedValue,
        };
        delete tempObj[key];
        columnNameNotFound = false;
      }
    });
    if (columnNameNotFound) {
      tempObj = {
        ...columnMapper,
        [columnName]: selectedValue,
      };
    }
    setColumnMapper(tempObj);
  };

  const getFieldName = (value: string) => {
    const options =
      getMatchDropdownDataSource({
        source,
        customFields,
        projectLevelFields,
      }) || [];
    const matchedOption = options.find((option: any) => option.value === value);
    return matchedOption?.name || value;
  };

  const autoMatching = async () => {
    let temp: any = {};
    if (source == excelImportSources.SCHEDULE) {
      allColumnNames.map((column) => {
        if (requiredFields.includes(column)) {
          if (!excludeAutoMatchingColumns.includes(column)) {
            temp = {
              ...temp,
              [column]: column,
            };
          }
        }
      });
      setColumnMapper(temp);
    } else if (source == excelImportSources.FILES) {
      allColumnNames.map((column) => {
        const matchedField = requiredFields.find((field: any) => field.headerText == column);
        if (matchedField) {
          temp = {
            ...temp,
            [column]: matchedField.value || column,
          };
        }
      });
      setColumnMapper(temp);
    } else if (source == excelImportSources.ASSETS) {
      allColumnNames.map((column: any) => {
        const matchedField = requiredFields.find(
          (field: any) => field.headerText?.toLowerCase() == column.toLowerCase(),
        );
        if (matchedField) {
          temp = {
            ...temp,
            [column]:
              column == "Asset Tag"
                ? "assetTag"
                : column == "Asset Name"
                  ? "assetName"
                  : matchedField.value || column.toLowerCase(),
          };
        }
      });
      setColumnMapper(temp);
    } else {
      allColumnNames.map((column: any) => {
        if (requiredFields.includes(column)) {
          temp = {
            ...temp,
            [column]: column == "HSN/SAC" ? "HSN_SAC" : column == "Purchase Unit Name" ? "unit" : column.toLowerCase(),
          };
        }
      });
      setColumnMapper(temp);
    }
  };

  const validatorFunction = async () => {
    if (source === excelImportSources.SCHEDULE) {
      validateScheduleData({
        sourceId: params.scheduleId,
        filteredJsonData,
        notValidPredecessors,
        setEnableNextButton,
        setScheduleIcorrectData,
        setIsScheduleDataValid,
        setButtonLoading,
        setFinalData,
        columnMapper,
        startDateTypeFormat,
        finishDateTypeFormat,
        wbsPathTypeIndex,
      });
    } else if (source === excelImportSources.ESTIMATE || source === excelImportSources.COST_DATABASE) {
      validateEstimateData({
        source,
        sourceId,
        estimateData,
        headerIndex,
        filteredJsonData,
        purchaseUnitsList,
        setEstimateIcorrectData,
        setButtonLoading,
        setIsEstimateDataValid,
        setEnableNextButton,
        setFinalData,
        columnMapper,
        dispatch,
      });
    } else if (source === excelImportSources.FILES) {
      await saveContainers({
        filteredJsonData,
        setFinalData,
        setButtonLoading,
        columnMapper,
        extraFields: customFields,
        setEnableNextButton,
        currentData,
      });
    } else if (source === excelImportSources.ASSETS) {
      await validateAssetData({
        sourceId,
        filteredJsonData,
        setFinalData,
        setEnableNextButton,
        setButtonLoading,
        extraFields: customFields,
        projectLevelFields,
        columnMapper,
      });
    }
  };

  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setFile(file);
      if (file.name.split(".").pop() == "xml") {
        setIsXml(true);
      } else {
        setIsXml(false);
      }
      setEnableNextButton(true);
    } else {
      setEnableNextButton(false);
    }
  };

  const showValidateData = () => {
    if (source == excelImportSources.FILES) {
      const dateTimeFieldsMap: Record<string, string | undefined> = {};
      requiredFields
        .filter((f: any) => f.fieldType === "date-time")
        .forEach((f: any) => {
          dateTimeFieldsMap[f.headerText] = f.displayAs;
        });
      return getGridComponent({
        dataSource: finalData,
        columnNames: allColumnNames,
        isValidateState: true,
        source,
        dateTimeFields: Object.keys(dateTimeFieldsMap),
        dateTimeFieldsMap,
        allowExport: true,
      });
    }
    if (source == excelImportSources.SCHEDULE) {
      if (isScheduleDataValid || isXml) {
        return scheduleFinalTreeGrid({ dataSource: finalData });
      }
      const allData: any = [];
      finalData.map((data: any) => {
        let isFound = false;
        scheduleIcorrectData.map((error: any) => {
          if (error.id == data.customTaskId) {
            isFound = true;
            allData.push(error);
          }
        });
        if (!isFound) {
          data.startDate = data.startDate
            ? typeof data.startDate == "string"
              ? data.startDate
              : new Date(data.startDate)
            : null;
          data.endDate = data.endDate
            ? typeof data.endDate == "string"
              ? data.endDate
              : new Date(data.endDate)
            : null;
          allData.push(data);
        }
      });
      const currentDataSource = showOnlyErrors ? scheduleIcorrectData : allData;
      return (
        <div>
          <div className="flex justify-between">
            <div className="mb-2 font-bold text-sm">{t("Following Rows have Errors.")}</div>
            <ToggleSwitchComponent
              label="Only Show Rows with error "
              checked={showOnlyErrors}
              onChange={() => setShowOnlyErrors(!showOnlyErrors)}
            />
          </div>
          {scheduleValidateGrid({ dataSource: currentDataSource })}
        </div>
      );
    }
    if (source == excelImportSources.ASSETS) {
      return (
        <SlickGrid1 dataset={finalData} columnDefinitions={assetsColumnDefinitions} gridOptions={{ rowHeight: 34 }} />
      );
    }
    if (isEstimateDataValid) {
      // had to do because in treeComponent "level" is reserved key and parentmapping should start with 1 either it didn't show all rows.
      const newData = finalData.map((item: any) => {
        const newItem = { ...item };
        delete newItem.level;

        newItem.rowNo = newItem.rowNo - 1;
        if (newItem.parent != "") {
          newItem.parent = newItem.parent - 1;
        } else {
          newItem.parent = null;
        }
        return newItem;
      });
      return estimateFinalTreeGrid({ dataSource: newData });
    }
    const allData: any = [];
    finalData.map((data: any) => {
      let isFound = false;
      estimateIcorrectData.map((error: any) => {
        if (error.row == data.rowNo) {
          isFound = true;
        }
      });
      if (!isFound) {
        allData.push(data);
      }
    });
    allData.push(...estimateIcorrectData);
    const currentDataSource = showOnlyErrors ? estimateIcorrectData : allData;
    return (
      <div className="flex flex-col h-full">
        <div className="flex justify-between pe-2">
          <div className="mb-2 font-bold text-sm">{t("Following Rows have Errors.")}</div>
          <ToggleSwitchComponent
            label="Only Show Rows with error "
            checked={showOnlyErrors}
            onChange={() => setShowOnlyErrors(!showOnlyErrors)}
          />
        </div>
        <div className="flex h-full overflow-auto">{estimateValidateGrid({ dataSource: currentDataSource })}</div>
      </div>
    );
  };

  useEffect(() => {
    if (currentTab == "Match Columns") {
      allColumnNames.map((col, index) => {
        const temp = Object.keys(columnMapper);
        if (!temp.includes(col)) {
          if (dropDownRef.current[index]) {
            dropDownRef.current[index].value = null;
          }
        }
      });
    }

    if (currentTab == "Validate Data" && isXml) {
      setEnableNextButton(true);
    }
  }, [columnMapper, currentTab]);

  useEffect(() => {
    fetchPortalPurchaseUnits();
    fetchCurrentFormTemplate();
    fetchProjectLevelFields();
  }, []);

  useEffect(() => {
    if (
      source == excelImportSources.SCHEDULE &&
      wbsPathTypeIndex != null &&
      startDateTypeFormat != null &&
      finishDateTypeFormat != null &&
      Object.keys(columnMapper).length == scheduleDropDownDataSource.length
    ) {
      setEnableNextButton(true);
    } else if (source === excelImportSources.FILES) {
      // Enable when every mandatory expected field has a mapped column. Optional columns
      // (e.g. Folder Name, Revision) shouldn't block — a strict count match breaks the
      // moment any optional column is missing or has a header mismatch.
      const mappedValues = new Set(Object.values(columnMapper));
      const mandatoryMapped = requiredFields
        .filter((f: any) => f?.isMandatory)
        .every((f: any) => mappedValues.has(f.value || f.headerText));
      setEnableNextButton(mandatoryMapped);
    } else if (
      (source == excelImportSources.ESTIMATE || source === excelImportSources.COST_DATABASE) &&
      Object.keys(columnMapper).length == requiredFields.length
    ) {
      setEnableNextButton(true);
    } else if (source == excelImportSources.ASSETS) {
      const allMapped =
        allColumnNames.length > 0 && allColumnNames.every((col: any) => columnMapper[col] && columnMapper[col] !== "");
      setEnableNextButton(allMapped);
    }
  }, [columnMapper, wbsPathTypeIndex, startDateTypeFormat, finishDateTypeFormat]);

  const getHeader = (headerName: any, index: any) => (
    <div className={currentTab == headerName ? "flex text-sm gap-1" : "flex opacity-20 text-sm gap-1"}>
      <span className="font-semibold h-5 w-5 flex justify-center items-center rounded-full bg-button_light">
        {index}
      </span>
      {headerName}
    </div>
  );

  const handleXmlSoftwareSelection = (args: any) => {
    setXmlSoftware(args.item.properties.text);
  };

  const handleCalendarSelection = (args: any) => {
    const tempWorkTimingsArray: any = [];
    const workTimingsTempdataSource: any = [];
    const tempdataSourceArray: any = [];
    const tempWorkingDays: any = [];
    const tempHolidays: any = [];
    let counter = 0;

    if (xmlSoftware == "P6") {
      calendarArray[args.item.properties.id].HolidayOrExceptions.HolidayOrException.map((day: any) => {
        if (day.WorkTime["@_xsi:nil"]) {
          tempHolidays.push({ FromDate: day.Date, ToDate: day.Date });
        }
      });
      setHolidays(tempHolidays);

      calendarArray[args.item.properties.id].StandardWorkWeek.StandardWorkHours.forEach((day: any) => {
        if (!day.WorkTime["@_xsi:nil"]) {
          tempWorkingDays.push(day.DayOfWeek);
          const worktimings: { from: number; to: number }[] = [];
          let tempdatasource = "";
          if (!day.WorkTime.length) {
            const fromHour = parseInt(day.WorkTime.Start.split(":")[0], 10);
            let toHour = parseInt(day.WorkTime.Finish.split(":")[0], 10);
            const finishMinutes = parseInt(day.WorkTime.Finish.split(":")[1], 10);
            if (finishMinutes !== 0) {
              toHour += 1;
            }
            worktimings.push({ from: fromHour, to: toHour });
            tempdatasource += `${fromHour}-${toHour}`;
          } else {
            day.WorkTime.forEach((range: any, index: number) => {
              const fromHour = parseInt(range.Start.split(":")[0], 10);
              let toHour = parseInt(range.Finish.split(":")[0], 10);
              const finishMinutes = parseInt(range.Finish.split(":")[1], 10);
              if (finishMinutes !== 0) {
                toHour += 1;
              }
              worktimings.push({ from: fromHour, to: toHour });
              tempdatasource += `${fromHour}-${toHour}`;
              if (index < day.WorkTime.length - 1) {
                tempdatasource += " , ";
              }
            });
          }

          if (!tempdataSourceArray.includes(tempdatasource)) {
            tempdataSourceArray.push(tempdatasource);
            tempWorkTimingsArray.push(worktimings);
            workTimingsTempdataSource.push({
              text: tempdatasource,
              id: counter,
            });
            counter += 1;
          }
        }
      });
    } else if (xmlSoftware == "MSP") {
      const tempWorkTiming: any = [];

      calendarArray[args.item.properties.id].WeekDays.WeekDay.map((day: any) => {
        if (day.DayType == 0 && day.DayWorking == 0) {
          tempHolidays.push(day.TimePeriod);
        } else if (day.DayType > 0 && day.DayWorking == 1) {
          tempWorkTiming.push(day.WorkingTimes.WorkingTime);
          tempWorkingDays.push(dayNames[day.DayType % 7]);
        }
      });

      tempWorkTiming.map((day: any) => {
        const worktimings: { from: number; to: number }[] = [];
        let tempdatasource = "";
        if (!day.length) {
          const fromHour = parseInt(day.FromTime.split(":")[0], 10);
          let toHour = parseInt(day.ToTime.split(":")[0], 10);
          const finishMinutes = parseInt(day.ToTime.split(":")[1], 10);
          if (finishMinutes !== 0) {
            toHour += 1;
          }
          worktimings.push({ from: fromHour, to: toHour });
          tempdatasource += `${fromHour}-${toHour}`;
        } else {
          day.forEach((range: any, index: number) => {
            const fromHour = parseInt(range.FromTime.split(":")[0], 10);
            let toHour = parseInt(range.ToTime.split(":")[0], 10);
            const finishMinutes = parseInt(range.ToTime.split(":")[1], 10);
            if (finishMinutes !== 0) {
              toHour += 1;
            }
            worktimings.push({ from: fromHour, to: toHour });
            tempdatasource += `${fromHour}-${toHour}`;
            if (index < day.length - 1) {
              tempdatasource += " , ";
            }
          });
        }
        if (!tempdataSourceArray.includes(tempdatasource)) {
          tempdataSourceArray.push(tempdatasource);
          tempWorkTimingsArray.push(worktimings);
          workTimingsTempdataSource.push({ text: tempdatasource, id: counter });
          counter += 1;
        }
      });
      setHolidays(tempHolidays);
    }
    setTimingsDropdownDatasource(workTimingsTempdataSource);
    setWorkWeek(tempWorkingDays);
    setSelectedCalendar(args.item.properties.text);
    setWorkTimingsArray(tempWorkTimingsArray);
    setWorkTimingsForDropdown("");
  };

  const handleTimingsSelection = (args: any) => {
    setWorkTimings(workTimingsArray[args.item.properties.id]);
    setWorkTimingsForDropdown(timingsDropdownDatasource[args.item.properties.id].text);
    setEnableNextButton(true);
  };

  const getSizeForColumn = () => (source === excelImportSources.COST_DATABASE ? 225 : 160);
  const getHeaderLine = () => <div className="border-black border-b-2 w-10 opacity-20" />;

  const importModalContent = () => {
    if (currentTab == "Upload File") {
      const fieldsToShow = requiredFields;
      const dataForFields = exampleFields;
      return (
        <div className="h-full p-6">
          <div className="">
            <div className="font-bold text-xl"> {t("Upload File")} </div>
            <div className="mt-4 font-bold text-lg"> {t("Data that we expect:")} </div>
            <div className="text-sm"> {t("(You will have a chance to rename or remove columns in next steps)")}</div>
          </div>
          <div className="mt-6" style={{ height: "9.375rem" }}>
            {getGridComponent({
              dataSource: dataForFields,
              columnNames: fieldsToShow,
              source,
            })}
          </div>

          <div className=" mt-6 font-semibold text-sm">
            {t("Please")}{" "}
            <a
              href="#"
              className="hover:underline mx-1 cursor-pointer text-blue-400"
              onClick={(e) => {
                e.preventDefault();
                getSampleFile({ source, extraFields: customFields, projectLevelFields });
              }}
            >
              {t("download")}
            </a>{" "}
            {t("the template first and use the exact format when you upload in case of .XLS/.XLSX/.CSV files")}
          </div>

          <div className="mt-8 me-6 border-2 border-solid border-gray-200 w-full p-2">
            <label htmlFor="fileUploadExcelImport">
              <input
                type="file"
                accept=".xls,.xlsx,.csv,.xml"
                id="fileUploadExcelImport"
                className="hidden"
                onChange={handleFileUpload}
              />
              <div className="flex relative cursor-pointer">
                <div
                  className={`px-2 py-1 shadow-md rounded ${file ? "opacity-40" : ""}`}
                  style={{ backgroundColor: "#ecf3fe" }}
                >
                  {t("Upload File (.xlsx, .xls, .csv or .xml supported)")}
                </div>
                <span className="justify-center items-center ms-2 mt-1 text-sm">
                  {" "}
                  {file ? file.name : t("No File Chosen")}{" "}
                </span>
              </div>
            </label>
          </div>
          <div className="ms-4 text-sm">
            {t("**only imports data from the first sheet if your Excel file contains multiple sheets.")}
          </div>
          {isXml && (
            <div className=" flex items-center gap-6 mt-8 font-semibold text-sm">
              {t("Choose the software from which XML is exported")}
              <SelectDropDown
                cssClass="bg-primary_blue h-8 px-4 rounded-lg"
                items={xmlDropdownDatasource}
                select={handleXmlSoftwareSelection}
                content={xmlSoftware}
              />
            </div>
          )}
        </div>
      );
    }
    if (currentTab == "Select Header") {
      return (
        <div className="flex flex-col h-full p-6">
          <div className="font-bold text-xl h-6">{t("Select Header Row")}</div>
          <div className="mt-4 h-full">
            {getGridComponent({
              dataSource: allJsonData,
              columnNames: Object.keys(allJsonData[0]).filter((key) => key !== "id"),
              rowSelected: true,
            })}
          </div>
        </div>
      );
    }
    if (currentTab == "Match Columns") {
      return (
        <div className="p-6 h-full w-full flex flex-col">
          <div className="font-bold text-xl">{t("Match Columns")}</div>
          <div className="mt-4 font-bold text-md"> {t("Your Table")}</div>
          <div className="mt-4 h-full">
            {getGridComponent({
              dataSource: filteredJsonData,
              columnNames: allColumnNames,
              height: 100,
            })}
          </div>
          <div className="mt-8 font-bold text-md ">{t("Will Become")}</div>
          <div>
            <div className="flex w-full gap-3 py-5 overflow-x-auto">
              {allColumnNames.map((columnName: any, index: number) => (
                <div key={index} className="flex-1 flex-col">
                  <ToolTipComponent content={getFieldName(columnMapper[columnName])}>
                    <AutoComplete
                      key={index}
                      id={`${index}`}
                      ref={(ref) => (dropDownRef.current[index] = ref)}
                      options={getMatchDropdownDataSource({
                        source,
                        customFields,
                        projectLevelFields,
                      })}
                      valueField="value"
                      getOptionLabel={(option) => option?.name || ""}
                      value={columnMapper[columnName]}
                      onChange={(_event, newValue) => {
                        handleDropdownChange(newValue, columnName);
                      }}
                      sx={{ width: `${getSizeForColumn() / 16}rem`, minWidth: "6.25rem" }}
                      renderInput={(params) => <TextFieldComponent {...params} />}
                    />
                  </ToolTipComponent>
                  {columnMapper[columnName] == "WBSPath" && (
                    <div className="mt-6 gap-4">
                      <AutoComplete
                        options={wbsPathTypeDatasource}
                        valueField="index"
                        getOptionLabel={(option) => option?.name || ""}
                        value={wbsPathTypeIndex as any}
                        onChange={(_event, newValue) => {
                          setWbsPathTypeIndex(newValue?.index ?? null);
                        }}
                        sx={{ width: `${getSizeForColumn() / 16}rem`, minWidth: "6.25rem" }}
                        renderInput={(params) => <TextFieldComponent {...params} />}
                      />
                    </div>
                  )}
                  {columnMapper[columnName] == "Start" && (
                    <div className="mt-6 gap-4">
                      <AutoComplete
                        options={dateTypeDatasource}
                        valueField="value"
                        getOptionLabel={(option) => option?.name || ""}
                        value={startDateTypeFormat}
                        onChange={(_event, newValue) => {
                          setStartDateTypeFormat(newValue?.value ?? null);
                        }}
                        sx={{ width: `${getSizeForColumn() / 16}rem`, minWidth: "6.25rem" }}
                        renderInput={(params) => <TextFieldComponent {...params} />}
                      />
                    </div>
                  )}
                  {columnMapper[columnName] == "Finish" && (
                    <div className="mt-6 gap-4">
                      <AutoComplete
                        options={dateTypeDatasource}
                        valueField="value"
                        getOptionLabel={(option) => option?.name || ""}
                        value={finishDateTypeFormat}
                        onChange={(_event, newValue) => {
                          setFinishDateTypeFormat(newValue?.value ?? null);
                        }}
                        sx={{ width: `${getSizeForColumn() / 16}rem`, minWidth: "6.25rem" }}
                        renderInput={(params) => <TextFieldComponent {...params} />}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    }
    if (currentTab == "Validate Data") {
      return (
        <div className="flex flex-col h-full overflow-hidden p-6 w-full">
          <div className="flex justify-between">
            <div className="font-bold text-xl mb-3 h-6">{t("Validate Data")}</div>
          </div>
          <div className="flex-1 overflow-auto">{showValidateData()}</div>
          {isXml && (
            <div className=" flex items-center gap-4 font-semibold text-sm mt-4">
              {t("Select the calendar")}
              <SelectDropDown
                cssClass="bg-primary_blue px-4 rounded-lg"
                items={calendarDropdownDatasource}
                select={handleCalendarSelection}
                content={selectedCalendar}
              />
              <div className="ms-8">
                {" "}
                {t("Select week timings")}
                <SelectDropDown
                  cssClass="bg-primary_blue px-4 rounded-lg ms-4"
                  items={timingsDropdownDatasource}
                  content={workTimingsForDropDown}
                  select={handleTimingsSelection}
                />
              </div>
            </div>
          )}
          {source === excelImportSources.FILES && !showErrorReview && !importMode && (
            <div className="mt-4">
              <RadioGroup name="uploadOption" value={uploadOption} onChange={(e) => setUploadOption(e.target.value)}>
                <FormControlLabel
                  value="complete"
                  control={<Radio />}
                  label={<span className="text-sm">{t("Complete the Import Process")}</span>}
                />
                <FormControlLabel
                  value="uploadFiles"
                  control={<Radio />}
                  label={<span className="text-sm">{t("Upload Files to match Containers in the next step")}</span>}
                />
                <FormControlLabel
                  value="importDirectly"
                  control={<Radio />}
                  label={<span className="text-sm">{t("Import file directly")}</span>}
                />
              </RadioGroup>
            </div>
          )}
        </div>
      );
    }
  };

  const importFooterContent = () => {
    const getButtonText = () => {
      if (currentTab === "Validate Data") {
        if (source === excelImportSources.FILES && uploadOption === "uploadFiles") {
          return t("Next");
        }
        return t("Confirm");
      }
      return t("Next");
    };

    return (
      <div className="flex gap-4 pt-4 border-t">
        <ButtonComponent
          buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
          loading={buttonLoading}
          onClick={handleNextClick}
          disabled={!enableNextButton && !buttonLoading}
        >
          {getButtonText()}
        </ButtonComponent>

        {currentTab == "Upload File" ? (
          <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={() => setShowImportModal(false)}>
            {t("Cancel")}
          </ButtonComponent>
        ) : (
          <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={HandleGoBack}>
            {t("Go back")}
          </ButtonComponent>
        )}
      </div>
    );
  };

  const importHeaderContent = () => (
    <div className="w-full">
      <div className="flex justify-between w-full items-center ">
        <div>{t("Import Data")}</div>
      </div>
      <div className="flex items-center justify-center gap-6 mt-4">
        {getHeader("Upload File", 1)}
        {getHeaderLine()}
        {getHeader("Select Header", 2)}
        {getHeaderLine()}
        {getHeader("Match Columns", 3)}
        {getHeaderLine()}
        {getHeader("Validate Data", 4)}
      </div>
    </div>
  );

  const buildCalendarDropdownDatasource = (calendar: any) => {
    const temp: any = [];
    if (xmlSoftware == "P6") {
      calendar.forEach((data: any, index: number) => {
        temp.push({ text: data.Name, id: index });
      });
    } else if (xmlSoftware == "MSP") {
      calendar.forEach((data: any, index: number) => {
        if (data.WeekDays) {
          temp.push({ text: data.Name, id: index });
        }
      });
    }
    setCalendarArray(calendar);
    setCalendarDropdownDatasource(temp);
  };

  const handleConvert = () => {
    try {
      if (file) {
        const reader = new FileReader();
        let json: any = {};
        reader.onload = (e: any) => {
          try {
            const data = e.target.result;
            const fileExtention = file.name.split(".").pop();
            if (fileExtention === "xml") {
              if (typeof json == "string") {
                dispatch(
                  showToastNotification({
                    content: t("Something went wrong or the given file is not as per our Format."),
                    type: TOAST_TYPE_ERROR,
                  }),
                );
              } else {
                buildCalendarDropdownDatasource(json.calendar ? json.calendar : []);
                setFinalData(json.data);
                setCurrentTab("Validate Data");
              }
            } else if (["csv", "xls", "xlsx"].includes(fileExtention)) {
              const isCsv = fileExtention === "csv";
              if (isCsv) {
                json = parseCsvText(String(data));
                setAllJsonData(json);
                setCurrentTab("Select Header");
              } else {
                const workbook = XLSX.read(data, { type: "binary", cellDates: true });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]!]!;

                json = XLSX.utils.sheet_to_json(worksheet, {
                  header: 1,
                  blankrows: false,
                  raw: false,
                });
                const holidays: any = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[1]!]!, {
                  blankrows: false,
                  raw: false,
                });
                setHolidays(holidays);
                setAllJsonData(json);
                setCurrentTab("Select Header");
              }
            } else {
              dispatch(
                showToastNotification({
                  content: t("File format not supported"),
                  type: TOAST_TYPE_ERROR,
                }),
              );
            }
          } catch {
            dispatch(
              showToastNotification({
                content: t("Something went wrong or the given file is not as per our Format."),
                type: TOAST_TYPE_ERROR,
              }),
            );
          }
        };
        reader.readAsBinaryString(file);
      } else {
        dispatch(
          showToastNotification({
            content: t("file not selected"),
            type: TOAST_TYPE_ERROR,
          }),
        );
      }
    } catch {
      dispatch(
        showToastNotification({
          content: SOMETHING_WENT_WRONG,
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
  };

  const getIncorrectContainers = (responseData: any) => {
    return finalData.reduce((array: any, container: any, index) => {
      if (!responseData[index].status) {
        const backendError = responseData[index].message || "";
        array.push({
          ...container,
          type: backendError,
          errors: [...(container.errors || []), ...(backendError ? [backendError] : [])],
        });
      }
      return array;
    }, []);
  };

  const getCorrectContainers = (responseData: any) => {
    return finalData.reduce((array: any, container: any, index) => {
      if (responseData[index].status) {
        array.push({
          container,
          response: responseData[index],
          index,
        });
      }
      return array;
    }, []);
  };

  const handleImportExcel = async () => {
    let response;
    if (source == excelImportSources.ESTIMATE) {
      response = await saveEstimateItemsFromExcelSheet({ estimateId: sourceId, items: finalData });
    } else if (source === excelImportSources.SCHEDULE) {
      response = await importScheduleTasks({
        data: finalData,
        calendar: { holidays, workWeek, workTimings },
      });
    } else if (source === excelImportSources.COST_DATABASE) {
      response = await importCostDatabaseItemsFromExcelSheet({
        data: finalData,
        dsrId: sourceId,
      });
    } else if (source == excelImportSources.ASSETS) {
      response = await axiosWrapper.post<ImportAssetsFromExcelResponse>(
        `${getBackendUrl()}/assets/importAssetsFromExcel`,
        {
          assetData: finalData,
          projectId: sourceId,
        },
      );
    } else if (source == excelImportSources.FILES) {
      const formData = formDataGenerator(customFields);
      response = await importExcelContainers({
        data: finalData,
        currentData: {
          ...currentData,
          ...formData,
        },
      });
    }
    return response;
  };

  const formDataGenerator = (customFields: any) => {
    const returnObj: any = {};
    if (customFields?.[0]) {
      returnObj.formTemplateId = customFields[0]._id;
      returnObj.formFields = requiredFields.filter((x: any) => !!x.customFieldId);
    }
    return returnObj;
  };

  const openUploadModal = (correctData: any) => {
    const containerFiles = correctData
      .map(({ container, response }: any) => {
        const fileNameField = t("File Name");
        const fileFormatField = t("File Format");
        const folderNameField = t("Folder Name");
        const containerFileName = container[fileNameField];
        const containerFileFormat = container[fileFormatField];
        const containerFolderName = container[folderNameField] || "";
        const createdContainerId = response?.data?.fileId;
        const revisionLabel = String(container["Revision"] ?? container["revision"] ?? "").trim();
        const revisionSeriesId = container.revisionSeriesId;

        return {
          name: containerFileName,
          fileFormat: containerFileFormat,
          folderPath: containerFolderName,
          hierarchyId: createdContainerId,
          spaceId: currentData?.spaceId,
          revisionLabel,
          revisionSeriesId,
          startPattern: container.startPattern ?? null,
          sequenceType: container.sequenceType ?? null,
          sequenceRules: container.sequenceRules ?? null,
        };
      })
      .filter((f: any) => f.name && f.hierarchyId);

    const hierarchyId = currentData?.hierarchyId || "0";
    const spaceId = currentData?.spaceId;

    dispatch(
      setFileUploadProperties({
        [`${spaceId}_${hierarchyId}`]: {
          workspaceId: spaceId,
          fileUploadList: [],
        },
      }),
    );

    dispatch(
      setCurrentFileUploadProperties({
        workspaceId: spaceId,
        hierarchyId,
        currentFiles: containerFiles,
        currentFolderRef: {
          hierarchyId,
          name: currentData?.folderName || "/",
          filterPath: currentData?.filterPath || "/",
        },
        isFolderUpload: false,
        isUploadAllowed: true,
        isExcelImportFlow: true,
        excelImportContainers: containerFiles,
        formTemplate: customFields?.[0]
          ? { template: customFields[0].template, formTemplateId: customFields[0]._id }
          : { template: [] },
      }),
    );

    dispatch(maximiseFileUpload());
    setShowImportModal(false);
  };

  const openDirectImportModal = async () => {
    const fileNameField = t("File Name");
    const fileFormatField = t("File Format");
    const folderNameField = t("Folder Name");

    let folderStartPattern: string | null = null;
    let folderSequenceType: RevisionSequenceType | null = null;
    let folderSequenceRules: Required<RevisionSequenceRules> | null = null;
    if (currentData?.hierarchyId) {
      const series = await fetchRevisionSeries(currentData.hierarchyId);
      folderStartPattern = series.startPattern;
      folderSequenceType = series.sequenceType ?? null;
      folderSequenceRules = getEffectiveSequenceRules({
        defaultBehavior: series.defaultBehavior ?? undefined,
        sequenceRules: series.sequenceRules ?? undefined,
      });
    }

    const fp = (currentData?.filterPath || "").replace(/^\/+/, "").replace(/\/+$/, "");
    const fn = (currentData?.folderName || "").trim();
    const currentFolderPath = [fp, fn].filter(Boolean).join("/");

    const stripCurrentPath = (folderName: string) => {
      const trimmed = folderName.trim();
      if (currentFolderPath && trimmed.startsWith(currentFolderPath)) {
        return trimmed.slice(currentFolderPath.length).replace(/^\/+/, "");
      }
      return trimmed;
    };

    const containerDefinitions = finalData
      .map((container: any) => {
        const containerFileName = container[fileNameField];
        const containerFileFormat = container[fileFormatField];
        const containerFolderName = stripCurrentPath(container[folderNameField] || "");
        const revisionLabel = String(container["Revision"] ?? container["revision"] ?? "").trim();
        const revisionSeriesId = container.revisionSeriesId;

        return {
          name: containerFileName,
          fileFormat: containerFileFormat,
          folderPath: containerFolderName,
          spaceId: currentData?.spaceId,
          containerData: container,
          revisionLabel,
          revisionSeriesId,
        };
      })
      .filter((f: any) => f.name);

    const hierarchyId = currentData?.hierarchyId || "0";
    const spaceId = currentData?.spaceId;

    const existingFiles: any[] = [];
    const folderFilesMap: Record<string, any[]> = {};
    const allContainerFolderPaths = containerDefinitions.map((c: any) => c.folderPath || "");
    const uniqueFolderPaths = [...new Set(allContainerFolderPaths)];
    const currentFolderMarker = "__CURRENT_FOLDER__";
    const currentFolderFiles = await fetchFilesFromFolder(hierarchyId, spaceId, "this", true);
    currentFolderFiles.forEach((file: any) => {
      existingFiles.push({
        ...file,
        folderPath: currentFolderMarker,
      });
    });
    folderFilesMap[currentFolderMarker] = currentFolderFiles;
    for (const folderPath of uniqueFolderPaths) {
      const targetFolderId = await ensureFolderPathExists(folderPath, hierarchyId, spaceId);
      if (targetFolderId === hierarchyId) {
        folderFilesMap[folderPath] = currentFolderFiles;
        currentFolderFiles.forEach((file: any) => {
          existingFiles.push({
            ...file,
            folderPath: folderPath,
          });
        });
        continue;
      }

      const folderFiles = await fetchFilesFromFolder(targetFolderId, spaceId, "this", true);
      folderFiles.forEach((file: any) => {
        existingFiles.push({
          ...file,
          folderPath: folderPath,
        });
      });
      folderFilesMap[folderPath] = folderFiles;
    }

    containerDefinitions.forEach((c: any) => {
      const folderKey = c.folderPath || currentFolderMarker;
      const filesInFolder = folderFilesMap[folderKey] ?? folderFilesMap[currentFolderMarker] ?? [];
      const fullName = `${c.name}.${c.fileFormat}`.toLowerCase();
      const existing = filesInFolder.find((f: any) => String(f?.name || "").toLowerCase() === fullName);
      c.previousLabel = existing?.lastMarkedRevisionSeries?.label || existing?.revisionSeries?.label || null;
      c.existingLabels = Array.isArray(existing?.allRevisionLabels) ? existing.allRevisionLabels : [];
      c.startPattern = folderStartPattern;
      c.sequenceType = folderSequenceType;
      c.sequenceRules = folderSequenceRules;
    });

    dispatch(
      setFileUploadProperties({
        [`${spaceId}_${hierarchyId}`]: {
          workspaceId: spaceId,
          fileUploadList: [],
        },
      }),
    );

    const formData = formDataGenerator(customFields);

    dispatch(
      setCurrentFileUploadProperties({
        workspaceId: spaceId,
        hierarchyId,
        currentFiles: existingFiles,
        currentFolderRef: {
          hierarchyId,
          name: currentData?.folderName || "/",
          filterPath: currentData?.filterPath || "/",
        },
        isFolderUpload: false,
        isUploadAllowed: true,
        isDirectImportFlow: true,
        directImportContainers: containerDefinitions,
        directImportCurrentData: {
          ...currentData,
          ...formData,
        },
        directImportFolderFilesMap: folderFilesMap,
        formTemplate: customFields?.[0]
          ? { template: customFields[0].template, formTemplateId: customFields[0]._id }
          : { template: [] },
      }),
    );

    dispatch(maximiseFileUpload());
    setShowImportModal(false);
  };

  const hasMissingColumnInHeader = () => {
    if ([excelImportSources.ESTIMATE, excelImportSources.COST_DATABASE, excelImportSources.SCHEDULE].includes(source)) {
      return allColumnNames.length !== requiredFields.length;
    } else {
      const baseRequiredFields = requiredFields.filter((field: any) => !field.customFieldId);
      const requiredFieldNames = baseRequiredFields.map((field: any) => field.headerText?.toLowerCase().trim());
      const selectedColumnNames = allColumnNames.map((col: any) => col.toLowerCase().trim());
      const hasMissingColumns = requiredFieldNames.some((name: string) => !selectedColumnNames.includes(name));
      return hasMissingColumns || allColumnNames.length < baseRequiredFields.length;
    }
  };

  const handleNextClick = async () => {
    if (currentTab == "Upload File") {
      setButtonLoading(true);
      handleConvert();
      setEnableNextButton(false);
      setButtonLoading(false);
    } else if (currentTab == "Select Header") {
      const hasMissingColumn = hasMissingColumnInHeader();

      if (hasMissingColumn) {
        dispatch(
          showToastNotification({
            content: t("Selected header row has some missing column name."),
            type: TOAST_TYPE_WARNING,
          }),
        );
        return;
      }
      setCurrentTab("Match Columns");
      setEnableNextButton(false);
      autoMatching();
    } else if (currentTab == "Match Columns") {
      setEnableNextButton(false);
      setButtonLoading(true);
      await validatorFunction();
      setCurrentTab("Validate Data");
    } else if (currentTab == "Validate Data") {
      setButtonLoading(true);
      setEnableNextButton(false);

      try {
        if (source === excelImportSources.FILES) {
          if (finalData.length > MAX_EXCEL_IMPORT_CONTAINERS) {
            dispatch(
              showToastNotification({
                content: t("You can import a maximum of {{count}} rows at a time.", {
                  count: MAX_EXCEL_IMPORT_CONTAINERS,
                }),
                type: TOAST_TYPE_WARNING,
              }),
            );
            return;
          }
          if (uploadOption === "uploadFiles") {
            if (showErrorReview && validContainers.length > 0) {
              openUploadModal(validContainers);
              dispatch(
                showToastNotification({
                  content: t("{{validContainers_length}} container(s) ready. Now upload files to match them.", {
                    validContainers_length: validContainers.length,
                  }),
                  type: TOAST_TYPE_SUCCESS,
                }),
              );
              setButtonLoading(false);
              return;
            }

            const res: any = await handleImportExcel();
            if (res.data.status) {
              const arr = res.data.data;
              const incorrectData = getIncorrectContainers(arr);
              const correctData = getCorrectContainers(arr);

              if (correctData.length > 0) {
                setValidContainers(correctData);

                if (incorrectData.length > 0) {
                  setFinalData(incorrectData);
                  setShowErrorReview(true);
                  setEnableNextButton(true);
                  dispatch(
                    showToastNotification({
                      content: t(
                        "{{correctData_length}} container(s) created. {{incorrectData_length}} had issues and were skipped.",
                        { correctData_length: correctData.length, incorrectData_length: incorrectData.length },
                      ),
                      type: TOAST_TYPE_WARNING,
                    }),
                  );
                  setButtonLoading(false);
                  return;
                } else {
                  openUploadModal(correctData);
                  dispatch(
                    showToastNotification({
                      content: t("Containers created successfully. Now upload files to match them."),
                      type: TOAST_TYPE_SUCCESS,
                    }),
                  );
                  setButtonLoading(false);
                  return;
                }
              } else {
                setFinalData(incorrectData);
                setEnableNextButton(true);
                dispatch(
                  showToastNotification({
                    content: t("All containers have issues. Please fix them before uploading files."),
                    type: TOAST_TYPE_ERROR,
                  }),
                );
                setButtonLoading(false);
                return;
              }
            } else {
              dispatch(
                showToastNotification({
                  content: untranslated(res.data.message) || SOMETHING_WENT_WRONG,
                  type: TOAST_TYPE_ERROR,
                }),
              );
              setEnableNextButton(true);
              setButtonLoading(false);
              return;
            }
          } else if (uploadOption === "importDirectly") {
            await openDirectImportModal();
            dispatch(
              showToastNotification({
                content: t(
                  "Upload files to match with containers from Excel. Matching files will be uploaded directly.",
                ),
                type: TOAST_TYPE_SUCCESS,
              }),
            );
            setButtonLoading(false);
            return;
          } else if (uploadOption === "complete") {
            if (showErrorReview) {
              setShowImportModal(false);
              setButtonLoading(false);
              refreshDataGrid(true);
              return;
            }

            const res: any = await handleImportExcel();
            const toastData = {
              content: SOMETHING_WENT_WRONG,
              type: TOAST_TYPE_ERROR,
            };
            if (res.data.status) {
              const arr = res.data.data;

              if (arr.length == finalData.length) {
                const incorrectData = getIncorrectContainers(arr);
                const correctData = getCorrectContainers(arr);

                if (incorrectData.length) {
                  setFinalData(incorrectData);
                  setShowErrorReview(true);
                  setEnableNextButton(true);
                  toastData.type = TOAST_TYPE_WARNING;
                  toastData.content = t(
                    "{{correct}} container(s) imported successfully. {{incorrect}} had issues and were skipped.",
                    {
                      correct: correctData.length,
                      incorrect: incorrectData.length,
                    },
                  );
                  if (refreshDataGrid && typeof refreshDataGrid === "function") {
                    refreshDataGrid(true);
                  }
                } else {
                  setShowImportModal(false);
                  toastData.type = TOAST_TYPE_SUCCESS;
                  toastData.content = t("Imported Successfully!");
                  if (refreshDataGrid && typeof refreshDataGrid === "function") {
                    refreshDataGrid(true);
                  }
                }
              } else {
                setShowImportModal(false);
              }
            } else {
              setShowImportModal(false);
            }
            dispatch(showToastNotification(toastData));
            setButtonLoading(false);
            return;
          }
        }

        const res: any = await handleImportExcel();
        if (res.data.status) {
          const message =
            source == "assets"
              ? `${res.data.insertedCount} Assets imported Successfully`
              : t("Imported Successfully !!");
          setShowImportModal(false);
          dispatch(
            showToastNotification({
              content: untranslated(message),
              type: TOAST_TYPE_SUCCESS,
            }),
          );
          if (
            [excelImportSources.ESTIMATE, excelImportSources.COST_DATABASE, excelImportSources.ASSETS].includes(source)
          ) {
            refreshDataGrid(true);
          } else {
            window.location.reload();
          }
        } else {
          dispatch(
            showToastNotification({
              content: untranslated(res.data.message || res.data.errorMessage),
              type: TOAST_TYPE_ERROR,
            }),
          );
        }
      } catch {
        dispatch(
          showToastNotification({
            content: SOMETHING_WENT_WRONG,
            type: TOAST_TYPE_ERROR,
          }),
        );
      } finally {
        setButtonLoading(false);
        setEnableNextButton(true);
      }
    }
  };

  const HandleGoBack = () => {
    if (currentTab == "Select Header") {
      setCurrentTab("Upload File");
      if (file) setEnableNextButton(true);
    } else if (currentTab == "Match Columns") {
      setColumnMapper({});
      setCurrentTab("Select Header");
      setEnableNextButton(false);
    } else if (currentTab == "Validate Data") {
      if (isXml) {
        setCurrentTab("Upload File");
      } else {
        setCurrentTab("Match Columns");
      }
    }
  };

  return (
    <ModalStateDialogComponent
      height="80%"
      allowModalPadding={false}
      footerContent={importFooterContent()}
      width="80%"
      onCancel={() => setShowImportModal(false)}
      headerTitle={importHeaderContent()}
      isVisible={showImportModal}
      modelContent={importModalContent()}
    />
  );
}
export default ExcelImport;
